import React, { memo, useEffect } from 'react'
import Chip from '@material-ui/core/Chip'
import { makeStyles } from '@material-ui/styles'

import styles from './styles'
import { useTagsState } from '../reducer'
import { useArticleState } from '../../../../../reducer'
import { ETagActionType, ITag, EArticleActionTypes } from 'models'

const useStyles = makeStyles(styles)

const SelectedTags: React.FunctionComponent<{}> = () => {
	const classes = useStyles()
	const [, articleDispatch] = useArticleState()
	const [{ selected: selectedTags }, dispatch] = useTagsState()
	const deselect: any = (tag: ITag) => (event: MouseEvent) => {
		event.stopPropagation()
		dispatch({
			type: ETagActionType.deselect,
			tag,
		})
	}

	useEffect(() => {
		articleDispatch({
			type: EArticleActionTypes.seITagsWithouITagging,
			tags: selectedTags,
		})
	}, [selectedTags, articleDispatch])

	return (
		<>
			{selectedTags?.map((item: ITag) => (
				<Chip
					className={classes.chipActive}
					key={item.id}
					variant="outlined"
					label={item.title}
					clickable={true}
					onDelete={deselect(item)}
					onClick={deselect(item)}
				/>
			))}
		</>
	)
}

export default memo(SelectedTags)
